/**
 * Rounds a number based on its decimal places:
 * - If whole number, shows as is
 * - If has decimals, shows up to 3 decimal places
 * - Shows exact decimal places (1, 2, or 3) that exist in the number
 * @param {number} num - The number to round
 * @returns {number} - The rounded number
 */
export const roundNumber = (num) => {
  if (typeof num !== 'number') return num;
  
  // Get the decimal part
  const decimalStr = (num.toString().split('.')[1] || '');
  const decimalPlaces = decimalStr.length;
  
  // If it's a whole number or has no decimals, return as is
  if (decimalPlaces === 0) return num;
  
  // Otherwise return with appropriate number of decimals (max 3)
  const places = Math.min(decimalPlaces, 3);
  return Number(num.toFixed(places));
} 